import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../Translations';
import { shareStore } from '../../Stores/ShareStore';
import CopyableUrl from './CopyableUrl';

const ShareUrl: React.FC = () => {
  switch (shareStore.shareUrlState.kind) {
    case 'ready':
      return <CopyableUrl href={shareStore.shareUrlState.href} isLoading={false} />;
    case 'loading':
      return <CopyableUrl href={shareStore.shareUrlState.href} isLoading={true} />;
    case 'error':
      return (
        <div>
          <div className="mb-3 p-3 bg-amber-50 border border-amber-200 rounded-md text-sm text-amber-800">
            <T kind="Unable to load program-specific URL. Showing collection URL instead." />
          </div>
          <CopyableUrl href={shareStore.shareUrlState.href} isLoading={false} />
        </div>
      );
    case 'no-url':
      return (
        <div className="text-sm text-gray-600">
          <T kind="No share URL available for this collection." />
        </div>
      );
  }
};

export default observer(ShareUrl);
